import request from '../utils/request.js'
//获取订单详情
export function orderInfo(data) {
  return request({
    url:  '/rest/multi/order/pre',
    method: 'post',
    data: data
  })
}
//添加/删除/编辑地址获取详情
export function addAddrOrder(data) {
  return request({
    url:  '/rest/multi/order/pre?uaid=' + data.uaid + '&addrIdx=' + data.addrIdx,
    method: 'post',
    data: {}
  })
}
//提交订单
export function saveOrder(data) {
  return request({
    url:  '/rest/multi/order/save',
    method: 'post',
    data: data
  })
}


/**
 * 多地址获取购物金
 * **/
export function availableConsume(amount,spuId,rcgiList) {
  return request({
    url: '/rest/recharge/availableConsume2?amount=' + amount + '&gidListStr=' + spuId,
    method: 'post',
    data: {
      rcgiList:rcgiList
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/moreAddrOrder.js